import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LinhaExportacaoPonto } from './servico-exportacao-ponto';

@Component({
  selector: 'app-grade-folha-ponto',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './grade-folha-ponto.component.html'
})
export class GradeFolhaPontoComponent {
  @Input() linhas: LinhaExportacaoPonto[] = [];
  @Input() linhaEditando = '';
  @Input() batidasEdicao: string[] = ['', '', '', ''];

  @Output() batidasEdicaoChange = new EventEmitter<string[]>();
  @Output() editarOuSalvar = new EventEmitter<LinhaExportacaoPonto>();
  @Output() cancelarEdicao = new EventEmitter<void>();
  @Output() verHistorico = new EventEmitter<LinhaExportacaoPonto>();

  trackByLinha(_indice: number, linha: LinhaExportacaoPonto) {
    return linha.chave;
  }
}
